import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { getToken } from "../../utils/auth";


const CRMModalEditarSeguimiento = ({ show, onHide, registro, onGuardado }) => {
    const [fechaGestion, setFechaGestion] = useState("");
    const [observacion, setObservacion] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (registro) {
            setFechaGestion(
                new Date(registro.fechaGestion).toISOString().slice(0, 16)
            );
            setObservacion(registro.observacion || "");
        }
    }, [registro]);

    const handleGuardar = async () => {
        setLoading(true);
        const token = getToken();

        try {
            const response = await fetch(process.env.REACT_APP_API_CRM_EDITAR_SEGUIMIENTO, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    Token: token,
                    IdSeguimiento: registro.id,
                    FechaGestion: fechaGestion,
                    Observacion: observacion
                }),
            });

            if (response.ok) {
                Swal.fire("Éxito", "Gestión actualizada correctamente", "success");
                if (onGuardado) onGuardado();
                onHide();
            } else {
                Swal.fire("Error", "No se pudo actualizar", "error");
            }
        } catch (error) {
            console.error(error);
            Swal.fire("Error", "Error de conexión", "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered backdrop="static">
            <Modal.Header closeButton className="bg-warning">
                <Modal.Title>Editar Gestión</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Fecha de gestión</Form.Label>
                        <Form.Control
                            type="datetime-local"
                            value={fechaGestion}
                            onChange={(e) => setFechaGestion(e.target.value)}
                        />
                    </Form.Group>

                    <Form.Group>
                        <Form.Label>Observación</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={observacion}
                            onChange={(e) => setObservacion(e.target.value)}
                        />
                    </Form.Group>

                    <small className="text-muted d-block mt-2">
                        ⚠️ La fecha de próximo contacto se recalculará automáticamente.
                    </small>
                </Form>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancelar
                </Button>
                <Button variant="warning" onClick={handleGuardar} disabled={loading}>
                    {loading ? <Spinner size="sm" /> : "Guardar Cambios"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CRMModalEditarSeguimiento;
